module.exports = __webpack_public_path__ + "img/invite_rule.50ce6fad.png";